<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link> >
      <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link> >
      <router-link :to="'/persona_vacunapers/' + p_idAtencion + '/' + p_numero + '/' + p_idPersona + '/' + p_edad">Vacunas</router-link>
      > Vacunas Aplicadas
    </div>
    <hr>

    <h3 class="mt-4 mb-3">Vacunas Aplicadas</h3>

    <DataTable
      :data="vacunasAplicadas"
      :columns="columnasVacuna"
      idField="idVacunaPers"
      :acciones="false"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay vacunas aplicadas."
      @refresh="cargarDatos"
    />

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import api from "@/services/api";

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      p_idPersona:  0,
      p_idAtencion: 0,
      p_numero:     '',
      p_edad:       0,
      vacunacionData: [],
      columnasVacuna: [
        { field: 'vacunaNombre', label: 'Vacuna' },
        { field: 'descripcion',  label: 'Descripción' },
        {
          field: 'fechaApli',
          label: 'Fecha de Aplicación',
          format: (val) => {
            if (!val) return '';
            const d     = new Date(val);
            const day   = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year  = d.getFullYear();
            return `${day}-${month}-${year}`;
          },
        },
      ],
    };
  },
  computed: {
    vacunasAplicadas() {
      return this.vacunacionData.map(item => ({
        idVacunaPers: item.idVacunaPers,
        vacunaNombre: item.vacunaNombre,
        descripcion:  this.getDescripcion(item),
        fechaApli:    item.fechaApli,
      }));
    },
  },
  methods: {
    async cargarDatos() {
      try {
        const response = await api.get(`/vwvacunaperss/idpersona/${this.p_idPersona}`);
        this.vacunacionData = response.data;
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    },
    getDescripcion(item) {
      let desc = item.observacion || '';
      if (item.vacunaProdNombre) desc += '; ' + item.vacunaProdNombre;
      if (item.lote)             desc += '; ' + item.lote;
      return desc;
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.p_idPersona  = this.$route.params.p_idpersona;
    this.p_idAtencion = this.$route.params.p_idatencion;
    this.p_numero     = this.$route.params.p_numero;
    this.p_edad       = this.$route.params.p_edad;
    this.cargarDatos();
  },
};
</script>

<style scoped>
.breadcrumb-container { margin-bottom: 15px; }
</style>